import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

interface IProps {
  title: string;
  children: ReactNode;
}

const Container = styled.div`
  padding: 8px 16px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  body.dark & {
    background-color: rgba(0, 0, 0, 0.6);
  }
`;
const Title = styled.div`
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${theme.colors.secondary800};
`;

const GetStartedLinks = ({ title, children }: IProps) => (
  <Container>
    <Title>{title}</Title>
    {children}
  </Container>
);

export default GetStartedLinks;
